import React from 'react';
import { Button, Modal, Space } from 'antd';
import percentBadge from '../../user_profile/assets/images/badge-percent-blue.svg';
import '@splidejs/react-splide/css';
import { ImageSlider } from '../../common/components/sliders';
import '../assets/css/brands.css';
import MarkdownContent from '../../common/MarkdownContent';
import PhoneCircleIcon from '../assets/images/PhoneCircleIcon';
import EmailCircleIcon from '../assets/images/EmailCircleIcon';
import { useUpdateBrandEngagementMutation } from '../brandsSlice';

const BrandDetailsModal = ({ visible, onClose, brandData }) => {
  const [updateEngagement] = useUpdateBrandEngagementMutation();
  let offerButton = null;
  const link = brandData?.offer_link || brandData?.website_link;
  if (link) {
    offerButton = (
      <Button
        href={link}
        onClick={() =>
          updateEngagement({ brand_id: brandData?.id, source: 'brand_web' })
        }
        target='_blank'
        className='sb-blue-gradient-bg-right border-1 sb-blue-border-300 mg-bottom-15 white gSemiBold brFull fs-18 txt-center w-full max-w-300 pd-10 h-fit txt-wrap antd-link-button-override'
      >
        View {brandData?.offer_link ? 'Offer' : 'Site'}
      </Button>
    );
  }

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={offerButton}
      width='min(90%, 40rem)'
      centered
      closeable
      className='brand-details-modal'
      bodyStyle={{ padding: '0' }}
    >
      {/* Background Image Section */}
      <ImageSlider
        images={[brandData.logo_image]
          .concat(brandData?.gallery_images ?? [])
          .filter((img) => img)
          .map((src) => ({ src, alt: brandData.brand_name }))}
        height={'300px'}
        hideImageCount
        showButtons
        openOnClick
        showDots={Boolean(
          brandData?.gallery_images?.filter?.((img) => img)?.length
        )}
      />

      {/* Content Section */}
      <div className='brand-content pd-20'>
        {/* Brand Name and Subtitle */}
        <h1 className='gBold fs-24 mg-bottom-8 mg-top-0'>
          {brandData.brand_name}
        </h1>
        <h2 type='secondary' className='gRegular fs-18 grey-400 mg-bottom-15'>
          {brandData.subheading}
        </h2>
        <Space direction='horizontal' wrap={true} size={20}>
          {brandData?.phone_number?.trim?.() && (
            <div className='sb-blue-800 gMedium fs-16 display-flex-row row-center'>
              <PhoneCircleIcon className='fs-21 mg-right-5' />
              <a
                className='txt-nowrap sb-blue-800 hover:sb-blue-600'
                href={`tel:${brandData.phone_number}`}
              >
                {brandData.phone_number}
              </a>
            </div>
          )}
          {brandData?.email?.trim?.() && (
            <div className='sb-blue-800 gMedium fs-16 display-flex-row row-center'>
              <EmailCircleIcon className='fs-21 mg-right-5' />
              <a
                className='txt-nowrap sb-blue-800 hover:sb-blue-600'
                href={`mailto:${brandData.email}`}
              >
                {brandData.email}
              </a>
            </div>
          )}
        </Space>

        {/* Description */}
        <MarkdownContent
          className='brand-description fs-15 gMedium lh-1.66 mg-bottom-30'
          content={brandData.description}
        />

        {/* Discount Code Section */}
        {brandData?.discount_code && (
          <div
            className='mg-auto-lr'
            style={{ minWidth: 'min(400px, 100%)', maxWidth: 'fit-content' }}
          >
            <div className='display-flex-row gap-05r gBold fs-15 mg-bottom-8'>
              <img src={percentBadge} alt='%' /> Discount Code
            </div>

            <div className='border-1 seagreen-border-400 seagreen-bg-50 seagreen-700 br5 fs-36 gBold txt-center pd-17 pd-left-25 pd-right-25 lh-1 mg-bottom-15'>
              {brandData.discount_code}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default BrandDetailsModal;
